import api from 'apis/user';
import { HTTP_GET, HTTP_POST, WebApiRequest } from "tools/webservice";

export const getMultiFactorMethodsForUser = (internetUserId, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/users/${internetUserId}/multifactor`,
  successCallback,
  errorCallback,
  mountedRef,
});
export const setMultiFactorMethodsForUser = (internetUserId, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/users/${internetUserId}/multifactor`,
  payload,
  successCallback,
  mountedRef,
});
export const verifyMultiFactorMethodsForUser = (internetUserId, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/users/${internetUserId}/multifactor/verify`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const setMultiFactorVerifyStart = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/account/login/multifactor/verify/start`,
  payload,
  successCallback,
  mountedRef,
});
export const setMultiFactorVerifyCheck = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/account/login/multifactor/verify/check`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const resetPassword = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.resetPassword(),
  payload,
  successCallback,
  mountedRef,
});
export const getPasswordDefinitions = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getPasswordDefinitions(),
  successCallback,
  mountedRef,
});